/* eslint-disable prefer-object-spread, default-param-last */
// import { MANAGER } from '../constants/action_type';

const initialState = {};

const managerReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default managerReducer;
